import {Component, OnDestroy, OnInit} from '@angular/core';
import {getAppThemeName} from 'src/app/core/functions/common.function';
import {debounceTime, fromEvent, Subscription} from "rxjs";
import {Router} from "@angular/router";
import {DBAlertModule} from "@db/db-core";
import {TranslateModule} from "@ngx-translate/core";
import {CommonModule} from "@angular/common";

@Component({
  selector: 'irreversible-operation-banner',
  templateUrl: './irreversible-operation-banner.header.component.html',
  styleUrls: ['./irreversible-operation-banner.header.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    DBAlertModule,
    TranslateModule
  ]
})
export class IrreversibleOperationBannerHeaderComponent implements OnInit, OnDestroy {
  public width: number = window.innerWidth;
  private resizeSubscription?: Subscription;

  public getThemeName?: string;
  constructor(
    private readonly router: Router
  ) { }

  ngOnInit() {
    this.getThemeName = getAppThemeName();
    this.resizeSubscription = fromEvent(globalThis, 'resize')
      .pipe(debounceTime(100))
      .subscribe(() => {
        this.width = window.innerWidth;
      });
  }

  ngOnDestroy() {
    this.resizeSubscription?.unsubscribe();
  }

  isErrorPage () {
    return this.router.url === '/error'
  }

  protected readonly getAppThemeName = getAppThemeName;
}
